<div [ngClass]="{'card': !isMobileOffcanvas, 'shadow-mb': !isMobileOffcanvas}"
  class="  p-3 searchbar-wrapper searchbar-card ">

  <div class="searchbar-grid">

    <div #countryOrigin class="grid-item left justify-content-center" [ngClass]="{'active': dropdown === 'country'}"
      (click)="toggleDropdown('country', $event)">
      <app-shimmer-loader height="46px" *ngIf="loadingCountries"></app-shimmer-loader>
      <div *ngIf="!loadingCountries"
        class="d-flex align-items-center justify-content-start w-100 grid-content text-muted">
        <i class="ti ti-world text-muted mx-1"></i>
        <small>{{ searchFlow.selectedCountry?.code | countryName : searchFlow.selectedCountry?.name }}</small>
      </div>

      <ng-container *ngIf="dropdown === 'country'">
        <div class="dropdown-card" @dropdownAnimation>

          <div *ngFor="let country of searchFlow.allCountries" (click)="selectCountry(country)"
            class="d-flex align-items-center list-row border-top">
            <i class="bi bi-geo-alt me-2"></i>
            <span class="country-name"> {{ country.code | countryName : country.name }}</span>
          </div>
        </div>
      </ng-container>

    </div>

    <div #regionOrigin class="grid-item region justify-content-center" [ngClass]="{'active': dropdown === 'region'}"
      (click)="toggleDropdown('region', $event)">
      <app-shimmer-loader height="46px" *ngIf="loadingRegions"></app-shimmer-loader>
      <div *ngIf="!loadingRegions"
        class="d-flex align-items-center justify-content-start w-100 grid-content text-muted">
        <i class="ti ti-map-pin  mx-1"></i>
        <small *ngIf="searchFlow.selectedRegion">
          {{ searchFlow.selectedRegion.name | placeName }}
        </small>
        <small *ngIf="!searchFlow.selectedRegion" class="text-muted text-truncate d-inline-block w-100">
          {{ 'All Regions' | translate }}
        </small>
      </div>

      <ng-container *ngIf="dropdown === 'region'">
        <div class="dropdown-card pb-2" @dropdownAnimation>
          <div (click)="selectRegion(undefined)" class="d-flex align-items-center list-row">
            <i class="ti ti-list me-2"></i>
            {{ 'all_f' | translate }}
          </div>
          <div *ngFor="let region of searchFlow.allRegions" (click)="selectRegion(region)" class="list-row border-top">
            <app-country-list [region]="region.name | placeName"
              [country]="searchFlow.selectedCountry?.code | countryName : searchFlow.selectedCountry?.name"></app-country-list>
          </div>
        </div>
      </ng-container>

    </div>

    <div *ngIf="false" #districtOrigin class="grid-item middle" (click)="toggleDropdown('district', $event)">
      <app-shimmer-loader height="46px" *ngIf="loadingDistricts"></app-shimmer-loader>
      <div *ngIf="!loadingDistricts" class="d-flex align-items-center justify-content-start w-100 grid-content">
        <i class="ti ti-building-community me-2"></i>
        <small *ngIf="searchFlow.selectedDistrict" class="text-truncate d-inline-block w-100"
          style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          {{ searchFlow.selectedDistrict?.name | placeName }}
        </small>

        <small *ngIf="!searchFlow.selectedDistrict" class="text-muted text-truncate d-inline-block w-auto"
          style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          {{ 'Select district' | translate }}
        </small>
      </div>

      <ng-container *ngIf="dropdown === 'district'">
        <div class="dropdown-card" @dropdownAnimation>
          <div *ngFor="let district of searchFlow.allDistricts" (click)="selectDistrict(district)"
            class="d-flex align-items-center list-row">
            <i class="ti ti-map-pin me-2"></i>
            {{ district.name | placeName }}
          </div>
        </div>
      </ng-container>
    </div>

    <div [ngClass]="{'d-none d-md-flex': !isHomePage}" class="grid-item button justify-content-end">
      <button #searchButton id="searchButton"
        class="btn btn-primary right-button d-flex align-items-center justify-content-center"
        (click)="navigateToSearch()">
        <i class="ti ti-search me-2"></i>
        {{ 'Search' | translate }}
      </button>
    </div>

  </div>
</div>